import type { MessageDefinitions } from '@dsx/react';

import enUS from './en-US.json';

const messages: MessageDefinitions<typeof enUS> = {
	'en-US': enUS,
};

export default messages;
